<template>
	<header id="header">

		<openpay-charge ref="openpayCharge"/>

		<div class="t-250 fixed-button mrecharge" v-bind:class="{ 'active' : showBtn }" @click="$refs.openpayCharge.displayOnly()">
			<span class="icon"><i class="fas fa-phone"></i></span>¡Recarga aquí!
		</div>


		<router-link class="t-250 fixed-button portability" :class="{ 'active': showBtn }" v-if="this.$route.name != 'portabilityPage'" to="/portabilidad">
			<span class="icon"><i class="fas fa-mobile-android"></i></span>¡Cambiate a<br />Skycel!
		</router-link>

		<div class="header-content" id="header-content">

			<div class="header-menu">
				<b-navbar toggleable="lg" type="light" variant="light">
					<div class="container oversized-container">
						<b-navbar-brand to="/">
							<img src="public/images/logo.svg" alt="Skycell">
						</b-navbar-brand>

						<b-navbar-toggle target="nav-collapse"><i class="fas fa-bars bar-icon"></i></b-navbar-toggle>

						<b-collapse id="nav-collapse" is-nav>
							<b-navbar-nav class="ml-auto">

								<!-- <b-nav-item v-if="$route.name != 'homePage'" to="/">Inicio</b-nav-item> -->

								<li class="nav-item">
									<router-link class="nav-link" to="/cobertura">Cobertura</router-link>
								</li>

								<!-- <li class="nav-item" v-if="$route.name == 'homePage'">
									<router-link class="nav-link" to="/#h-paquetes" v-scroll-to="'#h-paquetes'">Paquetes</router-link>
								</li> -->

								<b-nav-item-dropdown right>
									<template #button-content>
										<span>Paquetes</span>
									</template>
									<b-dropdown-item to="/paquetes/movilidad">Movilidad</b-dropdown-item>
									<b-dropdown-item to="/paquetes/mifi">MiFi</b-dropdown-item>
									<b-dropdown-item to="/paquetes/casa">Casa</b-dropdown-item>
								</b-nav-item-dropdown>

								<li class="nav-item">
									<router-link class="nav-link" to="/portabilidad">Portabilidad</router-link>
									<!-- <router-link class="nav-link" to="/#h-portabilidad" v-scroll-to="'#h-portabilidad'">Portabilidad</router-link> -->
								</li>
								<li class="nav-item">
									<router-link class="nav-link" to="/compatibilidad">Compatibilidad</router-link>
								</li>
								<li class="nav-item">
									<router-link class="nav-link" to="/equipos">Equipos</router-link>
								</li>
								<b-nav-item-dropdown right>
									<template #button-content>
										<span>Skycel</span>
									</template>
									<b-dropdown-item to="/sucursales">Sucursales y contactos</b-dropdown-item>
									<b-dropdown-item to="/comunicados">Comunicados</b-dropdown-item>
									<b-dropdown-item to="/empresa">Empresa</b-dropdown-item>
									<b-dropdown-item to="/glosario">Glosario</b-dropdown-item>
									<b-dropdown-item to="/preguntas-frecuentes">Preguntas frecuentes</b-dropdown-item>
									<b-dropdown-item to="/contacto">Contáctanos</b-dropdown-item>
								</b-nav-item-dropdown>

								<!-- <li class="nav-item no-hoverline">
                  					<a class="nav-link" href="tel:0000000000"><i class="fas fa-phone-alt"></i> <span class="ml-1 d-lg-none">¡Llámanos!</span></a>
                				</li> -->

								<b-nav-item-dropdown right>
									<template #button-content>
										<span>
											<i class="fas fa-user d-xl-none"></i>
											<span class="d-lg-none d-xl-inline" v-if="isLogged">Mi cuenta</span>
											<span class="d-lg-none d-xl-inline" v-else>Acceso</span>
										</span>
									</template>
									<!-- <b-dropdown-item to="/ayuda">Ayuda</b-dropdown-item> -->
									<template v-if="isLogged">
										<b-dropdown-item to="/usuario/mis-datos">Mi cuenta</b-dropdown-item>
										<b-dropdown-item @click="tryToLogout()">Cerrar sesión</b-dropdown-item>
									</template>
									<template v-else>
										<b-dropdown-item to="/login">Iniciar sesión</b-dropdown-item>
										<b-dropdown-item to="/registrarse">Registrarse</b-dropdown-item>
									</template>
								</b-nav-item-dropdown>

								<li class="nav-item no-hoverline">
									<router-link class="nav-link" to="/cart">
										<i class="fas fa-shopping-cart"></i> 
										<span lass="ml-1 d-lg-none">Mi carrito</span>
									</router-link>
								</li>

								<!-- <b-nav-item to="">Cobertura</b-nav-item>
                					<b-nav-item to="">Paquetes</b-nav-item> -->
								<!-- <b-nav-item to="/contacto">Contacto</b-nav-item> -->

								<li class="nav-item nav-apps">
									<span class="nav-link">
										<span class="title">¡Descarga la App!</span>
										<a class="btn-app" target="_blank"
											href="https://play.google.com/store/apps/details?id=com.sustam.skycel&hl=es">
											<img src="public/images/shared/google-play.svg">
										</a>

										<a class="btn-app" target="_blank" href="https://apps.apple.com/us/app/skycel/id1616697589">
											<img src="public/images/shared/app-store.svg">
										</a>
									</span>
								</li>
							</b-navbar-nav>
						</b-collapse>
					</div>
				</b-navbar>
			</div>

			<div class="header-buttons">
				<a class="t-250 _btn" @click="$refs.openpayCharge.displayOnly()">
					<h1 class="ml12">Recarga aquí</h1>
				</a>
			</div>

		</div>

	</header>
</template>

<script>
import OpenpayCharge from '../daniel/openpay-charge'
import { mapActions, mapGetters } from 'vuex';
export default {

  	components: { OpenpayCharge },

	data() {
		return {
			showBtn: false,
		}
	},

	computed: {
		...mapGetters(['isLogged', 'getUser'])
	},

	methods: {
		...mapActions(['authAsk4LogOut']),
		async tryToLogout(){
			await this.authAsk4LogOut()
			setTimeout(()=> {
				if(!this.isLogged)
					this.$router.replace('/')
			}, 150)
		},
		handleAction(event) {
			var scrollY = window.scrollY;
			var headerHeight = document.getElementById("header-content").offsetHeight;

			document.getElementById("header").style.height = headerHeight + 'px';

			if (scrollY >= headerHeight) {
				this.showBtn = true;
			}
			else {
				this.showBtn = false;
			}
		},
		tryAnimate(){
			// Wrap every letter in a span
			var textWrapper = document.querySelector('.ml12');
			textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

			anime.timeline({loop: true})
			.add({
				targets: '.ml12 .letter',
				translateX: [40,0],
				translateZ: 0,
				opacity: [0,1],
				easing: "easeOutExpo",
				duration: 1200,
				delay: (el, i) => 500 + 30 * i
			}).add({
				targets: '.ml12 .letter',
				translateX: [0,-30],
				opacity: [1,0],
				easing: "easeInExpo",
				duration: 1100,
				delay: (el, i) => 100 + 30 * i
			});
		}
	},

	mounted() {
		this.handleAction();
		this.tryAnimate()
	},

	created() {
		window.addEventListener('scroll', this.handleAction);
		window.addEventListener('resize', this.handleAction);
	},

	destroyed() {
		window.removeEventListener('scroll', this.handleAction);
		window.removeEventListener('resize', this.handleAction);
	},
}
</script>

<style lang="less">
.ml12 {
	font-weight: 200;
	font-size: 1.0em;
	text-transform: uppercase;
	letter-spacing: 0.5em;
	.letter {
		display: inline-block;
		line-height: 1em;
	}
}
</style>